import snackbar from './snackbar.vue'

export default {
  install(Vue) {
    const $snackbar = (text, color) => {
      const promise = new Promise((resolve, reject) => {
        try {
          const comp = new Vue(snackbar);
          comp.$mount();
          document.querySelector('.main-content').appendChild(comp.$el);
          Object.assign(comp, { text, color });
          comp.$on('closed', () => {
            comp.isVisible = false;
            resolve();
            window.setTimeout(() => comp.$destroy(), 1000);
          })
          comp.isVisible = true
        } catch (err) {
          reject(err);
        }
      })
      return promise
    }

    Vue.prototype.$snackbar = $snackbar;
  }
}
